// src/bootstrap.ts

// Nascondi la schermata di loading quando l'app parte
window.addEventListener('load', () => {
  setTimeout(() => {
    const loading = document.getElementById('loading');
    if (loading) {
      loading.style.opacity = '0';
      loading.style.transition = 'opacity 0.3s ease-out';
      setTimeout(() => loading.remove(), 300);
    }
  }, 500);
});

// Fallback: se React non monta e ci sono errori globali
window.addEventListener('error', (event) => {
  console.error('Global error:', (event as ErrorEvent).error);

  const rootEmpty = !document.querySelector('#root > *');
  if (rootEmpty) {
    const loading = document.getElementById('loading');
    if (loading) loading.remove();

    const wrapper = document.createElement('div');
    wrapper.className = 'error-container';
    wrapper.innerHTML = `
      <div class="error-icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
      </div>
      <h1 class="error-title">Errore di Caricamento</h1>
      <p class="error-message">
        Si è verificato un errore durante il caricamento dell'applicazione.<br>
        Verifica la connessione internet e riprova.
      </p>
      <a class="error-button" href="/">Ricarica Pagina</a>
    `;
    document.body.innerHTML = '';
    document.body.appendChild(wrapper);
  }
});
